import { render } from "./SidebarHeader.vue?vue&type=template&id=6335d872&scoped=true&lang=pug"
import script from "./SidebarHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&setup=true&lang=js"

import "./SidebarHeader.vue?vue&type=style&index=0&id=6335d872&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6335d872"]])

export default __exports__